import React, { forwardRef } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { TransitionProps } from "@material-ui/core/transitions";
import { Button, Dialog, AppBar, Toolbar, IconButton, Typography, Slide } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import DialogStaticForm from "../../dialogStaticForm/DialogStaticForm";
import { FullScreenCustomPlanViewDialogProps } from "../../../../@types/components/dialogProps.types";

import "./fullScreenCustomPlanViewDialog.scss";
import VEBDialogStaticForm from "../../dialogStaticForm/VEBDialogStaticForm";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		appBar: {
			position: "relative",
			backgroundColor: "#3a4652"
		},
		title: {
			marginLeft: theme.spacing(2),
			flex: 1,
			fontWeight: 900
		}
	})
);

const Transition = forwardRef(function Transition(
	props: TransitionProps & { children?: React.ReactElement },
	ref: React.Ref<unknown>
) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const FullScreenCustomPlanViewDialog = ({
	planDetails,
	planDialogOpenStatus,
	handleClickOpen,
	handleClose,
	planType
}: FullScreenCustomPlanViewDialogProps) => {
	// console.log("1. planDialogOpenStatus => ", planDialogOpenStatus, "\n2. planDetails => \n", planDetails);
	const classes = useStyles();
	console.log("this is the plan details123", planDetails);
	return (
		<div>
			<Button variant="outlined" color="primary" onClick={handleClickOpen}>
				Open full-screen dialog
			</Button>
			<Dialog fullScreen open={planDialogOpenStatus} onClose={handleClose} TransitionComponent={Transition}>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<Typography variant="h6" className={classes.title}>
							Plan Details
						</Typography>
						<IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
							<CloseIcon />
						</IconButton>
					</Toolbar>
				</AppBar>
				{planType ? (
					<VEBDialogStaticForm planDetails={planDetails} />
				) : (
					<DialogStaticForm planDetails={planDetails} />
				)}
				{/* <DialogStaticForm planDetails={planDetails} /> */}
			</Dialog>
		</div>
	);
};

export default FullScreenCustomPlanViewDialog;
